import React, { useReducer, useEffect } from 'react'
import { LocationContext } from './context'
import { reducer, init } from './reducer'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'

interface LocationContextProviderProps {
  children: React.ReactNode
  entityId: number
  entityType: ENTITY_TYPES
  locations: LocationDTO[]
}

const LocationContextProvider: React.FC<LocationContextProviderProps> = (
  props,
) => {
  const { children, locations = [], ...rest } = props

  const [state, dispatch] = useReducer(reducer, { ...rest, locations }, init)

  useEffect(() => {
    dispatch({
      type: 'RESET_FROM_PROPS',
      payload: { ...rest, locations },
    })
  }, [rest.entityId, rest.entityType, locations])

  return (
    <LocationContext.Provider value={{ state, dispatch }}>
      {children}
    </LocationContext.Provider>
  )
}

export default LocationContextProvider
